import { render } from "./Prestador_TarifaPres.vue?vue&type=template&id=d94a1f18"
import script from "./Prestador_TarifaPres.vue?vue&type=script&lang=js"
export * from "./Prestador_TarifaPres.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__